import { initializeApp, type FirebaseApp, type FirebaseOptions } from 'firebase/app';
import { getAuth, type Auth } from 'firebase/auth';
import { getFirestore, type Firestore } from 'firebase/firestore';
import { getStorage, type FirebaseStorage } from 'firebase/storage';
import { getFirebaseConfig } from '~/config/firebaseConfig';

let firebaseInitialized = false;
let firebaseApp: FirebaseApp | null = null;
let firebaseAuth: Auth | null = null;
let firebaseFirestore: Firestore | null = null;
let firebaseStorage: FirebaseStorage | null = null;

export default defineNuxtPlugin(nuxtApp => {
  // Lazy initialize Firebase only when needed
  const initializeFirebase = () => {
    if (!firebaseInitialized) {
      const firebaseConfig = getFirebaseConfig();
      firebaseApp = initializeApp(firebaseConfig as FirebaseOptions);
      firebaseAuth = getAuth(firebaseApp);
      firebaseFirestore = getFirestore(firebaseApp);
      firebaseStorage = getStorage(firebaseApp);
      firebaseInitialized = true;
    }
    return {
      app: firebaseApp!,
      auth: firebaseAuth!,
      firestore: firebaseFirestore!,
      storage: firebaseStorage!
    };
  };

  // Only initialize on routes that need Firebase
  nuxtApp.hook('page:start', () => {
    const route = useRoute();
    if (route.path === '/standings' || route.path.startsWith('/standings') || 
        route.path === '/matches' || route.path.startsWith('/match')) {
      const firebase = initializeFirebase();
      nuxtApp.provide('firebase', firebase);
    }
  });

  // Provide a getter that initializes on first use
  nuxtApp.provide('firebase', new Proxy({} as any, {
    get(target, prop) {
      const firebase = initializeFirebase();
      return firebase[prop as keyof typeof firebase];
    }
  }));
});
